invalidRequired:
    en: "Can't be empty"
    ru: 'Не может быть пустым'
    es: 'No puede estar vacío'
    pt: 'Não pode estar vazio'
    fr: 'Ne doit pas être vide'
invalidGreatThan:
    en: "Can't be great than {0}"
    ru: 'Не может быть больше {0}'
    es: 'No puede ser más grande que {0}'
    pt: 'Não pode ser maior do que {0}'
invalidLessThan:
    en: "Can't be less than {0}"
    ru: 'Не может быть меньше {0}'
    es: 'No puede ser más pequeño que {0}'
    pt: 'Não pode ser menor do que {0}'
    fr: 'Ne peut pas être inférieur à {0}'
invalidNumber:
    en: 'This field should be a number'
    ru: 'Это поле должно быть числом'
    es: 'Este campo debería se un número'
    pt: 'Este campo deve conter um número'
    fr: 'Ce champ doit contenir un nombre'
invalidInt:
    en: 'This field must be an integer'
    ru: 'Это поле должно быть целым числом'
    es: 'Este campo debería se un integro'
    pt: 'Este campo deve conter um inteiro'
invalidEmail:
    en: 'This field should be an e-mail address in the format "xxxxxx@domain.com"'
    ru: 'Это поле должно содержать адрес электронной почты в формате "xxxxxx@domain.com"'
    es: 'Este campo debe ser una dirección de correo electrónico con el formato "xxxxxx@dominio.com"'
    fr: 'Ce champ doit contenir une adresse email au format: "xxxxxx@domaine.com"'
    pt: 'Este campo deve ser um endereço de Email no formato ""xxxxxx@domain.com'
invalidDayjs:
    en: 'Invalid datetime format'
    ru: 'Недопустимый формат даты и времени'
    es: 'Formato Fecha Hora inválido'
    pt: 'Formato horário inválido'
invalidMaxLength:
    en: "Text length can't be greater than {0}"
    ru: 'Длина текста не может быть больше {0}'
    es: 'La longitud del texto no puede ser más grande que {0}'
    pt: 'A dimensão do texto não pode ser maior do que {0}'
    fr: 'La longueur du texte ne doit pas dépasser {0}'
invalidMinLength:
    en: "Text length can't be less than {0}"
    ru: 'Длина текста не может быть меньше {0}'
    es: 'La longitud del texto no puede ser menor que {0}'
    pt: 'A dimensão do texto não pode ser menor do que {0}'
    fr: 'La longueur du texte ne peut pas être inférieure à {0}'
startSameThanEnd:
    en: 'Time values cannot be the same'
    ru: 'Время начала не должно быть равно времени конца'
    es: 'Los valores de tiempo no pueden ser el mismo'
    pt: 'Os valores horários não podem ser iguais'
startLessThanEnd:
    en: 'Start time should be before end time'
    ru: 'Время начала должно быть меньше времени конца'
    es: 'La hora de inicio debería ser anterior a la hora final'
    pt: 'A hora de início não pode ser depois da hora de fim'
    fr: "'L'heure de début doit être antérieure à l'heure de fin'"
startDateLessThanEnd:
    en: 'Start date should be before end date'
    es: 'La fecha de inicio debería ser anterior a la fecha final'
    ru: 'Дата начала должна быть меньше даты окончания'
    pt: 'A hora de início deve ser anterior à hora final'
passwordsDoNotMatch:
    en: 'Passwords do not match'
    es: 'La contraseña no se empareja'
    fr: 'Les mots de passe ne correspondent pas'
    pt: 'As senhas não coincidem'
    ru: 'Пароли не совпадают'
passwordIsShort:
    en: 'Password must be at least {0} characters'
    es: 'La contraseña debe tener como mínimo {0} caracteres'
    ru: 'Пароль должен быть не менее {0} символов'
    pt: 'A senha deve ter pelo menos {0} carateres'
dateRequired:
    en: Date cannot be empty
    ru: Поле "Дата" не может быть пустым
    es: Fecha no puede estar vacía
    pt: Data não pode estar vazia
commentRequired:
    en: Comment cannot be empty
    ru: Поле "Комментарий" не может быть пустым
    es: Comentario no puede estar vacío
    pt: Comentário não pode estar vazio
wrongTerritory:
    en: Location is not in this territory
    ru: Местоположение не на этой территории
invalidW3W:
    en: This field should be a w3w address format, e.g. ///limit.broom.flip
    ru: Это поле должно содержать адрес в формате w3w, напр.  ///вишня.месить.продумать
    es: Este campo debe tener un formato de dirección w3w, por ejemplo ///préstamo.metido.plantas
    pt: Este campo deve ser um formato de endereço w3w, por ex. ///pagou.agem.crase
    fr: Ce champ doit contenir une adresse w3w, par exemple ///limit.broom.flip
#placeholders
namePlaceholder: 
    en: 'Enter name'
    es: 'Introduzca el nombre'
    fr: 'Entrez le nom'
    pt: 'Insira o nome'
    ru: 'Введите имя'
externalIdPlaceholder:
    en: 'Enter external ID'
    es: 'Introduzca el número externo'
    fr: 'Entrez l’ID externe'
    pt: 'Insira o ID externo'
    ru: 'Введите внешний идентификатор'
phonePlaceholder: 
    en: '+44 000 00 00'
    es: '+34 000 00 00'
    fr: '+33 000 00 00'
    pt: '+351 000 00 00'
    ru: '+7 000 000 00 00'
choosePlaceholder: 
    en: 'Choose'
    es: 'Elegir'
    fr: 'Choisir'
    pt: 'Escolher'
    ru: 'Выбрать'
loginPlaceholder: 
    en: 'Enter login'
    es: 'Introduzca el inicio de sesión'
    fr: 'Entrez le login'
    pt: 'Insira o login'
    ru: 'Введите логин'
emailPlaceholder: 
    en: 'Enter email'
    es: 'Introduzca el correo electrónico'
    fr: 'Entrez l’email'
    pt: 'Insira o email'
    ru: 'Введите email'
inputPlaceholder: 
    en: 'Input'
    es: 'Entrada'
    fr: 'Entrée'
    pt: 'Entrada'
    ru: 'Ввод'
